<template>
  <div class="tags">
    <el-tag
      v-for="(item,index) in tags"
      :key="item.name"
      :closable="item.name!=='home'"
      :effect="$route.name ===item.name?'dark':'plain'"
      size="small"
      @close="handleCloseTag(item,index)"
      @click="clickTag(item)"
    >
      {{item.label}}
    </el-tag>
  </div>
</template>

<script>
import {mapState,mapMutations} from 'vuex'
export default {
  name: "CommonTag",
  methods:{
    ...mapMutations('tab',['closeTag']),
    //点击Tag跳转
    clickTag(item){
      this.$router.push({name:item.name})
    },
    handleCloseTag(item,index){
      //调用store中的closeTag方法
      this.closeTag(item)
      const length=this.tags.length
      //如果关闭的不是当前路由，则直接返回
      if(item.name!==this.$route.name){
        return
      }
      //如果当前路由是最后一个，则跳转到倒数第二个
      if(index===length){
        this.$router.push({
          name:this.tags[index-1].name
        })
      }
      else//如果当前路由不是最后一个，则跳转到当前路由的后一个
      {
        this.$router.push({
          name:this.tags[index].name
        })
      }
    }
  },
  computed:{
    ...mapState({
      tags:state=>state.tab.tabsList
    })
  }
};
</script>

<style scoped>
.tags{
  margin-bottom: 10px;
  margin-top: -10px;
}
.el-tag{
  margin-right: 15px;
  cursor: pointer;
}
</style>